module.exports = __webpack_public_path__ + "img/21.8e7a4a14.png";